import { supabase } from '../../supabaseClient';

async function supbaseSignOut() {
  return supabase.auth.signOut();
}

export { supbaseSignOut };
